import React from 'react';
import PropTypes from 'prop-types';

const Image = props => {
  return <img alt={props.alt} src={props.source} {...props} />;
};

Image.propTypes = {
  /** URL of the image **/
  source: PropTypes.string.isRequired,
  /** alternative text of the image **/
  alt: PropTypes.string.isRequired,
};

Image.defaultProps = {
  source:
    'https://images.unsplash.com/photo-1449023859676-22e61b0c0695?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1789&q=80',
  alt: 'alt text',
};

export default Image;
